var space = {
  none: '0px',
  xxs: '2px',
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  xxl: '32px',
  xxxl: '64px'
};
var breakpoints = {
  mobile: '0em',
  tablet: '48em',
  desktop: '62em'
};
var fontFamilies = {
  default: "'sofia-pro', -apple-system, 'Segoe UI', Roboto, 'Open Sans', sans-serif",
  heading: "'sofia-pro', -apple-system, 'Segoe UI', Roboto, 'Open Sans', sans-serif",
  mono: 'Menlo, monospace'
};
var fontSizes = {
  caption: '.75rem',
  control: '.875rem',
  content: '1rem',
  heading6: '1.25rem',
  heading5: '1.5rem',
  heading4: '1.75rem',
  heading3: '2rem',
  heading2: '2.5rem',
  heading1: '4rem'
};
var fontWeights = {
  light: 200,
  regular: 400,
  medium: 500,
  bold: 700
};
var lineHeights = {
  regular: 1.5,
  heading: 1.25,
  control: 1.375
};
var typography = {
  caption: {
    fontFamily: fontFamilies.default,
    fontSize: fontSizes.caption,
    lineHeight: lineHeights.regular,
    fontWeight: fontWeights.regular
  },
  control: {
    fontFamily: fontFamilies.default,
    fontSize: fontSizes.control,
    lineHeight: lineHeights.control,
    fontWeight: fontWeights.regular
  },
  content: {
    fontFamily: fontFamilies.default,
    fontSize: fontSizes.content,
    lineHeight: lineHeights.regular,
    fontWeight: fontWeights.regular
  },
  heading6: {
    fontFamily: fontFamilies.heading,
    fontSize: fontSizes.heading6,
    lineHeight: lineHeights.heading,
    fontWeight: fontWeights.bold
  },
  heading5: {
    fontFamily: fontFamilies.heading,
    fontSize: fontSizes.heading5,
    lineHeight: lineHeights.heading,
    fontWeight: fontWeights.bold
  },
  heading4: {
    fontFamily: fontFamilies.heading,
    fontSize: fontSizes.heading4,
    lineHeight: lineHeights.heading,
    fontWeight: fontWeights.bold
  },
  heading3: {
    fontFamily: fontFamilies.heading,
    fontSize: fontSizes.heading3,
    lineHeight: lineHeights.heading,
    fontWeight: fontWeights.bold
  },
  heading2: {
    fontFamily: fontFamilies.heading,
    fontSize: fontSizes.heading2,
    lineHeight: lineHeights.heading,
    fontWeight: fontWeights.bold
  },
  heading1: {
    fontFamily: fontFamilies.heading,
    fontSize: fontSizes.heading1,
    lineHeight: lineHeights.heading,
    fontWeight: fontWeights.bold
  }
};
var textStyle = {
  caps: {
    textTransform: 'uppercase'
  }
};
var colors = {
  amethyst: '#7F85FF',
  amethystMedium: '#BFC2FF',
  amethystLight: '#DFE0FF',
  background: '#FFFFFF',
  backgroundDark: '#F5F5F5',
  backgroundSuccess: '#EFFDF1',
  border: '#DEDEE0',
  borderDark: '#BCBEC0',
  borderLight: '#ffffff',
  citrine: '#FFDE49',
  citrineMedium: '#FFEEA4',
  citrineLight: '#FFF7D1',
  danger: '#DC2222',
  dangerDark: '#b62121',
  dangerOutline: '#FBE8E8',
  dangerShadow: 'rgba(250,62,100,.1)',
  dangerText: '#FFFFFF',
  disabled: '#ececec',
  disabledShadow: 'rgba(0, 0, 0, 0.38)',
  disabledText: 'rgba(0, 0, 0, 0.38)',
  emerald: '#15DE93',
  emeraldMedium: '#8AEEC9',
  emeraldLight: '#C4F7E4',
  opacity: 'rgba(222,222,222,0.5)',
  opacityDark: 'rgba(55,55,55,0.8)',
  opacityLight: 'rgba(222,222,222,0.2)',
  opacityShadow: 'rgba(0,0,0,0.1)',
  peridot: '#98DE6A',
  peridotMedium: '#CBEEB4',
  peridotLight: '#E5F7DA',
  primary: '#0F0D08',
  primaryDark: '#12100c',
  primaryLight: '#353431',
  primaryOutline: '#e7e6e6',
  primaryShadow: 'rgba(15,13,8,.1)',
  primaryText: '#FFFFFF',
  ruby: '#FF5160',
  rubyMedium: '#FFA8AF',
  rubyLight: '#FFD3D7',
  secondary: '#1E70DD',
  secondaryDark: '#1e60b7',
  secondaryLight: '#1166DD',
  secondaryOutline: '#D2E2F8',
  secondaryShadow: 'rgba(30,112,221, .1)',
  secondaryText: '#FFFFFF',
  success: '#0A8A00',
  successLight: '#04BF81',
  successOutline: '#9DD099',
  successText: '#FFFFFF',
  text: '#242A33',
  textDark: '#000000',
  textLight: '#767676',
  topaz: '#FFA452',
  topazMedium: '#FFD1A8',
  topazLight: '#FFE8D4',
  turqouise: '#4CD4DD',
  turquoiseMedium: '#A5E9EE',
  turquoiseLight: '#D2F4F6',
  warning: '#FEC976',
  warningText: '#242A33'
};
var borders = {
  none: 0,
  regular: '1px solid',
  thick: '2px solid'
};
var radii = {
  none: '0px',
  sm: '2px',
  md: '6px',
  lg: '12px',
  xl: '24px',
  rounded: '100%',
  inherit: 'inherit'
};
var opacities = {
  disabled: 0.7
};
var transitions = {
  slow: '0.7s ease',
  fast: '0.3s ease',
  duration: {
    slow: '0.7s',
    fast: '0.3s',
    superFast: '0.1s',
    none: '0s'
  }
};
var shadows = {
  none: 'none',
  inset: 'inset 0px 11px 8px -10px rgba(0,0,0,0.12)',
  xs: '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
  sm: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
  md: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
  lg: '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
  xl: '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)'
};
var sizes = {
  xs: '24em',
  sm: '30em',
  md: '42em',
  lg: '60em'
};
var zIndices = {
  notification: 4,
  formActions: 10,
  selectMenu: 100,
  header: 1000,
  modal: 1000,
  tooltip: 2000
};
/**
 * Theme variables for Lucid applications
 */

export var BaseTheme = {
  fontWeights: fontWeights,
  fontFamilies: fontFamilies,
  lineHeights: lineHeights,
  fontSizes: fontSizes,
  space: space,
  breakpoints: breakpoints,
  borders: borders,
  radii: radii,
  typography: typography,
  colors: colors,
  opacities: opacities,
  transitions: transitions,
  shadows: shadows,
  textStyle: textStyle,
  zIndices: zIndices,
  sizes: sizes
};
export * from './responsive';
export * from './reset';